export const GET_DIARY = 'GET_DIARY';
export const SET_DIARY = 'SET_DIARY';
export const SET_DIARY_ENTRIES = 'SET_DIARY_ENTRIES';
export const GET_DIARY_WEEK = 'GET_DIARY_WEEK';
export const SET_DIARY_WEEK = 'SET_DIARY_WEEK';
export const SET_MY_DAILY_COMMENT = 'SET_MY_DAILY_COMMENT';
export const SET_DAILY_COMMENTS = 'SET_DAILY_COMMENTS';
export const UPDATE_DAILY_COMMENTS = 'UPDATE_DAILY_COMMENTS';
export const SET_MY_ANALYSIS_COMMENT = 'SET_MY_ANALYSIS_COMMENT';
export const SET_ANALYSIS_COMMENTS = 'SET_ANALYSIS_COMMENTS';
export const UPDATE_ANALYSIS_COMMENTS = 'UPDATE_ANALYSIS_COMMENTS';
export const PUBLISH_DIARY = 'PUBLISH_DIARY';
export const STORE_COMMENT = 'STORE_COMMENT';
export const SET_COMMENT = 'SET_COMMENT';
export const SET_ENTRY = 'SET_ENTRY';
export const SET_COURSE_SETTINGS = 'SET_COURSE_SETTINGS';
export const SET_COURSE_STATUSES = 'SET_COURSE_STATUSES';
export const SET_COURSE_MEALS = 'SET_COURSE_MEALS';
export const ADD_ABSENCE = 'ADD_ABSENCE';
export const SET_DIARY_MEDIA = 'SET_DIARY_MEDIA';
export const SET_DIARY_DOCUMENTS = 'SET_DIARY_DOCUMENTS';
export const ADD_DIARY_MEDIA = 'ADD_DIARY_MEDIA';
export const ADD_DIARY_DOCUMENT = 'ADD_DIARY_DOCUMENT';
export const UPLOAD_DIARY_MEDIA = 'UPLOAD_DIARY_MEDIA';
export const UPLOAD_DIARY_DOCUMENT = 'UPLOAD_DIARY_DOCUMENT';
export const UPDATE_DIARY_FILE = 'UPDATE_DIARY_FILE';
export const REMOVE_DIARY_MEDIA = 'REMOVE_DIARY_MEDIA';
export const DELETE_DIARY_FILE = 'DELETE_DIARY_FILE';
export const DELETE_DIARY_DOCUMENT = 'DELETE_DIARY_DOCUMENT';
export const REMOVE_DIARY_DOCUMENT = 'REMOVE_DIARY_DOCUMENT';
export const CREATE_DIARY = 'CREATE_DIARY';
export const CREATE_AND_PUBLISH_DIARY = 'CREATE_AND_PUBLISH_DIARY';
export const SET_DIARY_ERROR = 'SET_DIARY_ERROR';
export const SET_DIARY_HOLIDAYS = 'SET_DIARY_HOLIDAYS';
export const SET_DIARY_INTEGRATIONS = 'SET_DIARY_INTEGRATIONS';
export const LIKE_DIARY = 'LIKE_DIARY';
export const SET_DIARY_LIKES = 'SET_DIARY_LIKES';
export const SET_DAILY_NOTES = 'SET_DAILY_NOTES';
export const UPDATE_DAILY_NOTES = 'UPDATE_DAILY_NOTES';
export const SET_MY_DAILY_NOTES = 'SET_MY_DAILY_NOTES';
export const SAVE_ENTRY_STATUS = 'SAVE_ENTRY_STATUS';
export const SAVE_ENTRY_MEAL = 'SAVE_ENTRY_MEAL';
export const SET_ENTRY_MEALS = 'SET_ENTRY_MEALS';
export const UPDATE_ENTRIES_STATUSES = 'UPDATE_ENTRIES_STATUSES';
export const SAVE_ENTRY_FEEDBACK = 'SAVE_ENTRY_FEEDBACK';
export const UPDATE_ENTRY_FEEDBACK = 'UPDATE_ENTRY_FEEDBACK';
export const DELETE_ENTRY_FEEDBACK = 'DELETE_ENTRY_FEEDBACK';
export const REMOVE_ENTRY_FEEDBACK = 'REMOVE_ENTRY_FEEDBACK';
export const SET_ENTRY_FEEDBACK = 'SET_ENTRY_FEEDBACK';
export const START_ENTRY_TIME = 'START_ENTRY_TIME';
export const STOP_ENTRY_TIME = 'STOP_ENTRY_TIME';
export const ADD_ENTRY_TIME = 'ADD_ENTRY_TIME';
export const UPDATE_ENTRY_TIME = 'UPDATE_ENTRY_TIME';
export const DELETE_ENTRY_TIME = 'DELETE_ENTRY_TIME';
export const REMOVE_ENTRY_TIME = 'REMOVE_ENTRY_TIME';
export const SET_ENTRY_TIME = 'SET_ENTRY_TIME';
export const SET_LEAVE_TYPE = 'SET_LEAVE_TYPE';
export const UPDATE_ENTRY_LEAVE_STATUS = 'UPDATE_ENTRY_LEAVE_STATUS';
export const UPDATE_ENTRIES_LEAVE_STATUSES = 'UPDATE_ENTRIES_LEAVE_STATUSES';